<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/perfil"> Cadastro/Acesso/Perfis </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="4">
            <v-text-field
              label="Perfil *"
              v-model="nome"
              :counter="200"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              :readonly="readOnly"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="8">
            <v-autocomplete
              v-model="permissaoSelected"
              :items="filteredPermissao"
              label="Permissão *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              
              :rules="[(v) => !!v || 'A Permissão é obrigatória']"
              :readonly="readOnly"
              required
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Descrição"
              v-model="descricao"
              :counter="200"
              :readonly="readOnly"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isReqRolls">
          <v-col>
            <v-data-table
              :headers="headers"
              hide-default-footer
              :items="subRegra"
            >
              <template v-slot:item.acao="{ item }">
                <v-checkbox v-model="item.acao"></v-checkbox>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="perfil.ativo"
            @click.native.stop.prevent="checkAssociacao()"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/perfil" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/perfil" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarPerfilAsync } from "../../../services/perfilService";
import { mapState, mapActions } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";
import { getUserPermission } from "@/services/loginService";
import { possuiModuloComAcoesDePerfil } from "../../../utils/perfilActions";

export default {
  name: "editarPerfil",
  data: () => ({
    overlay: false,
    valid: true,
    nome: null,
    descricao: null,
    permissaoSelected: null,
    readOnly: false,
    headers: [
      { text: "Regra", value: "regra", sortable: false },
      { text: "Ação", value: "acao", sortable: false },
    ],
    subRegra: [
      {
        regra: "Aprovar",
        acao: false,
      },
      {
        regra: "Declinar",
        acao: false,
      },
      {
        regra: "Inativar",
        acao: false,
      },
      {
        regra: "Realizar baixa",
        acao: false,
      },
    ],
  }),
  computed: {
    ...mapState("perfil", ["perfil"]),
    ...mapState("permissao", ["permissoesRegras"]),
    ...mapState("usuario", ["usuarios"]),
    ...mapState("limite", ["limites"]),
    filteredPermissao() {
      return this.permissoesRegras.filter((p) => {
        return p.ativo === true;
      });
    },
    isReqRolls() {
      return possuiModuloComAcoesDePerfil(this.permissaoSelected);
    },
  },
  methods: {
    ...mapActions("usuario", ["atualizarUsuarios"]),
    ...mapActions("limite", ["atualizarLimites"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarPerfilAsync(
          this.perfil.id,
          this.nome,
          this.descricao,
          this.perfil.ativo,
          this.permissaoSelected.id,
          this.subRegra[0].acao,
          this.subRegra[1].acao,
          this.subRegra[2].acao,
          this.subRegra[3].acao
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(
            resposta.message,
            "Desculpe, falha na operação!",
            "error"
          );
        } else {
          /*this.$fire({
            text: "Usuário editado com sucesso",
            type: "success",
            timer: 3000,
          });*/
          this.overlay = false;
          this.$router.push("/perfil");
        }
      }
    },
    findPermissao(permissaoId) {
      return this.permissoesRegras.find((per) => per.id === permissaoId);
    },
    findUsuario(perfilId) {
      return this.usuarios.filter((u) => {
        return u.idPerfil == perfilId && u.ativo === true;
      });
    },
    findLimite(perfilId) {
      return this.limites.filter((l) => {
        return l.idPerfil == perfilId;
      });
    },
    checkAssociacao: async function () {
      if (!this.perfil.ativo) {
        if (!this.usuarios || this.usuarios.length == 0) {
          this.overlay = true;
          await this.atualizarUsuarios();
          this.overlay = false;
        }
        var usuarios = this.findUsuario(this.perfil.id);
        if (usuarios != null && usuarios.length > 0) {
          this.$alert(
            "O(s) usuário(s) '" +
              usuarios.map((e) => e.nome).join("', '") +
              "' estão ativos e associados a esse perfil.",
            "Ação não permitida!",
            "error"
          );
          this.perfil.ativo = !this.perfil.ativo;
          return;
        }
        if (!this.limites || this.limites.length == 0) {
          this.overlay = true;
          await this.atualizarLimites();
          this.overlay = false;
        }
        var limites = this.findLimite(this.perfil.id);
        if (limites != null && limites.length > 0) {
          this.$alert(
            "Existem limites cadastrados e associados a esse perfil.",
            "Ação não permitida!",
            "error"
          );
          this.perfil.ativo = !this.perfil.ativo;
          return;
        }
      }
    },
  },
  created: function () {
    this.readOnly = !getUserPermission(1);
    this.nome = this.perfil.nome;
    this.descricao = this.perfil.descricao;
    this.permissaoSelected = this.findPermissao(this.perfil.idPermissao);
    this.subRegra[0].acao = this.perfil.aprovar;
    this.subRegra[1].acao = this.perfil.declinar;
    this.subRegra[2].acao = this.perfil.inativar;
    this.subRegra[3].acao = this.perfil.baixar;
  },
  components: {
    TabNavegacao,
  },
};
</script>